<bz-menu appBringozIdGenerator="threepl-service-status-selector-menu"
         [ariaLabel]="'All Statuses' | translate"
         [items]="items()"
         (selected)="onSelected($event)">
  <span class="layout-row layout-align-start-center threepl-menu-trigger">
    {{ (selectedStatus() ? selectedStatus() : 'All Statuses') | translate }}
    <bz-icon [icon]="chevron"></bz-icon>
  </span>
</bz-menu>
